module.exports = __webpack_public_path__ + "img/TM.7f458b4c.svg";